import { useEffect, useRef } from 'react';

import { Notification } from './notification';
import { useNotifications } from './notifications-store';

export const Notifications = () => {
  const { notifications, dismissNotification } = useNotifications();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    if (container.matches(':popover-open')) container.hidePopover();
    if (notifications.length > 0) container.showPopover();
  }, [notifications]);

  return (
    <div
      ref={containerRef}
      popover="manual"
      aria-live="assertive"
      className="pointer-events-none fixed inset-0 z-[100] m-0 flex size-full max-h-none max-w-none flex-col items-end space-y-4 overflow-visible border-none bg-transparent px-4 py-6 sm:items-start sm:p-6"
    >
      {notifications.map((notification) => (
        <Notification
          key={notification.id}
          notification={notification}
          onDismiss={dismissNotification}
        />
      ))}
    </div>
  );
};
